import './Offer.scss';
import React from 'react';
import OfferItemCard from '../../components/offer-components/OfferItemCard';
import cardData from './offerData';
import "../experts/slick-theme.css";
import "../experts/slick.css";
import Slider from 'react-slick';
import cardDataMob from './offerDataMob';
import { useInView } from 'react-intersection-observer';


function Offer({t,handlerSelectModal}) {
  const{ ref,inView } = useInView({
    threshold:1,
  })
  const cardItem = cardData(t).map(item => (
    <OfferItemCard {...item } key={item.description} t={t}handlerSelectModal={handlerSelectModal}/>
  ));
  const cardItemMob = cardDataMob(t).map(item => (
    <OfferItemCard {...item} key={item.description} t={t}handlerSelectModal={handlerSelectModal}/>
  ))
  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 2,
    responsive: [
      {
        breakpoint: 1255,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          infinite: true,
          dots: true
        }
      },
      {
        breakpoint: 1025,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          infinite: true,
          dots: true
        }
      },
      {
        breakpoint: 880,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          initialSlide: 2
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]
  };
  return (
    <div className="offer-wrapper">
        <div className="offer-content-wrapper">
            <div className="offer-capture-box">
              <div ref={ref} className={`offer-capture animation ${inView ? 'show-ofer-capture': ""}`}>
                  {t("offer_capture")}
              </div>
              <div ref={ref} className={`offer-capture-description animation ${inView ? 'show-ofer-capture': ""}`}>
                {t("offer_description")}
              </div>
              <div className="offer-card-wrapper">
                {cardItem}
              </div>
              <div className="offer-card-wrapper-mobile">
                <Slider {...settings}>
                  {cardItemMob}
                </Slider>
              </div>
            </div>
        </div>
    </div>
  );
}

export default Offer;